<template>
    <div>


        <!-- Dialogo vinculado con acciones del dashboard-->
        <v-dialog v-model="isActive" :width="400" transition="dialog-bottom-transition" scrollable
            :fullscreen="$vuetify.breakpoint.mobile">
            <v-card class="rounded-0">
                <v-card class="rounded-0" dark height="50" flat>
                    <v-app-bar flat color="white">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn v-if="e1 !== 0" v-bind="attrs" v-on="on" icon @click.outside="volver"
                                    @keydown.esc="volver">
                                    <v-icon>mdi-arrow-left</v-icon>
                                </v-btn>
                                <v-btn v-else v-bind="attrs" v-on="on" icon @click.outside="cerrarDialogo"
                                    @keydown.esc="cerrarDialogo">
                                    <v-icon>{{ icon }}</v-icon>
                                </v-btn>
                            </template>
                            <span v-if="e1 == 0">Cerrar</span>
                            <span v-else>Atras</span>
                        </v-tooltip>
                        <v-toolbar-title>{{ titulo }}</v-toolbar-title>
                    </v-app-bar>
                    <v-card-text>
                        <FormEditarFoto v-if="e1 == 0" @abrirCamera="goToCamera" @abrirPreview="goToImage"
                            @cerraDialogo="cerrarDialogo" :tipo="this.tipo">
                        </FormEditarFoto>
                    </v-card-text>
                    <v-card-text>
                        <CameraCanvas v-if="e1 == 1" @fotoCargada="cargaFoto" @fotoDescarta="descartar"
                            :tipo="this.tipo">
                        </CameraCanvas>
                    </v-card-text>
                </v-card>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>

//Formularios
import FormEditarFoto from '@/components/forms/FormEditarFoto'
import CameraCanvas from '@/components/inputs/CameraCanvas'

import { mapActions, mapGetters } from 'vuex'

export default {

    components: {
        //componentes

        //Formularios
        FormEditarFoto,
        CameraCanvas,

    },
    data() {
        return {
            isActive: false,
            icon: 'mdi-close',

            width: 600,
            height: 600 / 1.33,
            capturado: false,

            //capture: false,
            fotoSubida: false
        }
    },
    props: ['titulo', 'tipo'],


    computed: {
        ...mapGetters('auth', ['isAuthenticated']),
        ...mapGetters('itemEdit', ['itemSelected']),
        ...mapGetters('notificaciones', ['loading']),
    },
    methods: {
        ...mapActions(['refreshData']),
        ...mapActions('notificaciones', ['showSnack']),
        ...mapActions('preafiliacion', ['addFotoCarnet']),

        //metodos de accion de dialogo
        cerrarDialogo() {
            // cierra el dialogo y elimina las variables almacenadas temporalmente
            // en el store

            this.refreshData()
            //se vacia el store itemEdit
            if (this.itemSelected) {
                this.vaciarItem()
            }
            this.isActive = false

        },
        abrirDialogo() {
            this.isActive = true
            this.activarVideo()
        },
        cargaFoto() {
            this.$emit('cargadaFoto', true)
            this.cerrarDialogo()
            this.showSnack({
                message: 'Archivo guardado correctamente',
                type: '200'
            })
        },
        descartar() {
            this.capturado = false
            this.addFotoCarnet('')
            this.activarVideo()
            this.$refs.canvas.width = 0

        },


        //metodos para el manejo del canvas
        async capture() {
            let capture = await navigator.mediaDevices.getUserMedia({ video: { width: 600, height: (600 / 1.33) } });
            let video = this.$refs.video;
            video.srcObject = capture;
            await video.play();
            let canvas = this.$refs.canvas;
            let ctx = canvas.getContext('2d');
            canvas.width = this.width;
            canvas.height = this.height;
            /**
            ctx.drawImage(image, sx, sy, sWidth, sHeight, dx, dy, dWidth, dHeight);
            */
            const sW = 400
            ctx.drawImage(video, 95, 80, sW, sW / 1.33, 0, 0, 600, 600 / 1.33);
            let dataURL = canvas.toDataURL('image/png');
            const arr = dataURL.split(',')
            console.log(arr[1])
            this.addFotoCarnet(arr[1])
            this.capturado = true
        },
        activarVideo() {
            this.$nextTick(() => {
                let video = this.$refs.video;
                navigator.mediaDevices.getUserMedia({ video: true })
                    .then(stream => {
                        //console.log(stream)
                        video.srcObject = stream
                        video.play()
                    })
            })
        },

    }

}

</script>